import React from 'react';

import {
  cryptoAssetsQuery,
  emptyFiltersQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const CryptoTable: React.FC<DynamicAssetTableProps> = (props) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={cryptoAssetsQuery}
      filtersQuery={emptyFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={4}
      tabletRows={2}
      mobileColumns={3}
      mobileRows={3}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Ativo' },
        { key: 'quantityNormalized', label: 'Quantidade' },
        { key: 'positionNormalized', label: 'Posição' },
        { key: 'resultNormalized', label: 'Resultado' },
        { key: 'profitabilityNormalized', label: 'Rentabilidade' },
        { key: 'valueNormalized', label: 'Valor atual' },
        { key: 'averagePriceNormalized', label: 'Preço médio' },
      ]}
    />
  );
};
